<template>
  <component
    :is="accessiblityComponents"
    v-if="accessiblityComponents"
  />
</template>

<script>
import { Vue } from 'vue-property-decorator';
import config from '@/config';
import { accessibilityComponentsMap } from './accessibility-map';

export default class AccessibilityReference extends Vue {
  get accessiblityComponents() {
    const name = (config.nameApp || '').toLowerCase();
    return accessibilityComponentsMap[name] || null;
  }
}
</script>
